// import * as moment from 'vue-moment';

export const dateShortCuts = (firstClickDate = null) => {
    return [
        {
            text: 'Today',
            onClick() {
                const date = new Date();
                return [date, date];
            },
        },
        {
            text: 'Yesterday',
            onClick() {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24);
                return [date, date];
            },
        },
        {
            text: 'Last 7 Days',
            onClick() {
                const date = new Date();
                let currentDate = moment(date);
                return [currentDate.subtract(7, 'days').toDate(), date];
            },
        },
        {
            text: 'Last 30 Days',
            onClick() {
                const date = new Date();
                let currentDate = moment(date);
                return [currentDate.subtract(30, 'days').toDate(), date];
            },
        },
        {
            text: 'This Month',
            onClick() {
                return [moment().startOf('month').toDate(), moment().endOf('month').toDate()];
            },
        },
        {
            text: 'Last Month',
            onClick() {
                const date = new Date();
                let pastMonth = moment().subtract(1,'month');
                return [pastMonth.startOf('month').toDate(), pastMonth.endOf('month').toDate()];
            },
        },
        {
            text: 'All time',
            onClick() {
                const date = new Date();
                let olderDate = firstClickDate ? new Date(firstClickDate) : new Date('01.01.1970');
                return [olderDate, date];
            },
        },
    ];
};

export const defaultDateRange = () => {
    let start_data = '';
    let end_data = '';

    if (Vue.$cookies.isKey("calendar_data_start") && Vue.$cookies.isKey("calendar_data_end")) {
        start_data = moment(Vue.$cookies.get("calendar_data_start")).toDate();
        end_data = moment(Vue.$cookies.get("calendar_data_end")).toDate();
    } else {
        const date = new Date();
        let currentDate = moment(date);
        start_data = currentDate.subtract(30, 'days').toDate();
        end_data = date;
    }
    return [start_data, end_data];
};

export const setCookiesDateRange = (start_data, end_data) => {
    if (start_data && end_data) {
        Vue.$cookies.set('calendar_data_start', start_data);
        Vue.$cookies.set('calendar_data_end', end_data);
    }
};

const doubleSplit = (str, sep1, sep2) => {
    let splitPart = str.split(sep1);
    for(let i = 0; i < splitPart.length; ){
        if(splitPart[i] === ''){ //delete
            splitPart.splice(i,1);
            continue;
        }
        let temp = splitPart[i].split(sep2);
        if(temp.length > 1){
            splitPart.splice(i,1, ...temp);
        }
        else i++;
    }
    return splitPart;
};

export const dateToString = (fromDate, toDate) => {
    let parseFromDate = fromDate.split(' ');
    let parseToDate = toDate.split(' ');
    if(parseFromDate[0] === parseToDate[0] && parseFromDate[1] === parseToDate[1] && parseFromDate[2] === parseToDate[2]) return parseFromDate[0]+' '+parseFromDate[1]+', '+parseFromDate[2];
    else if(parseFromDate[0] === parseToDate[0] && parseFromDate[2] === parseToDate[2]) return parseFromDate[0]+' '+parseFromDate[1]+' - '+parseToDate[1]+', '+parseFromDate[2];
    else if(parseFromDate[2] === parseToDate[2]) return parseFromDate[0]+' '+parseFromDate[1]+' - '+parseToDate[0]+' '+parseToDate[1]+', '+parseFromDate[2];
    else return parseFromDate[0]+' '+parseFromDate[1]+', '+parseFromDate[2]+' - '+parseToDate[0]+' '+parseToDate[1]+', '+parseToDate[2];
};

export const stringToDate = (stringDate) => {
    let parseDate = stringDate.split('-');
    if(parseDate.length !== 2) return null;

    let splitFirstPart = doubleSplit(parseDate[0], ' ', ',');
    let splitSecondPart = doubleSplit(parseDate[1], ' ', ',');

    let firstDate = moment('', 'MMM D YYYY');
    let secondDate = moment('', 'MMM D YYYY');
    if(splitFirstPart.length === 2 && splitSecondPart.length === 2){
        firstDate = moment(splitFirstPart[0]+' '+splitFirstPart[1]+' '+splitSecondPart[1], 'MMM D YYYY');
        secondDate = moment(splitFirstPart[0]+' '+splitSecondPart[0]+' '+splitSecondPart[1], 'MMM D YYYY');
    }
    else if(splitFirstPart.length === 2 && splitSecondPart.length === 3){
        firstDate = moment(splitFirstPart[0]+' '+splitFirstPart[1]+' '+splitSecondPart[2], 'MMM D YYYY');
        secondDate = moment(splitSecondPart[0]+' '+splitSecondPart[1]+' '+splitSecondPart[2], 'MMM D YYYY');
    }
    else if(splitFirstPart.length === 3 && splitSecondPart.length === 3){
        firstDate = moment(splitFirstPart[0]+' '+splitFirstPart[1]+' '+splitFirstPart[2], 'MMM D YYYY');
        secondDate = moment(splitSecondPart[0]+' '+splitSecondPart[1]+' '+splitSecondPart[2], 'MMM D YYYY');
    }

    return [firstDate, secondDate];
};
